<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      adPage: "Property Reservation",
      adSuburbs: "",
      adsData: "",
      disable: true,
      gray: true,
      cur: -1,
      curId: "",
      pm: {},
      datum: [],
      companyDetails: {},
      buyNowOrMakeOfferBtn: "Select now",
      privateMode: false,
    };
  },

  created() {
    console.log("Property Selection created");
    if (this.$route.path.slice(0,9) === '/private/') {
      this.privateMode = true;
    }
    this.getPropertyRoomList({
      params: {
        propertyId: this.$route.query.pid
      },
      callback: this.propertyRoomListCallback
    });
  },
  components: {},
  methods: {
    ...mapActions("property", ["getPropertyRoomList"]),

    reservePropertyForm() {
      // need to add the property id and room id. or is room id enough?
      console.log('redirecting to form')
      let componentName = this.privateMode ? "uConnectFormPrivate" : "uConnectForm";
      this.$router.push({
        name: componentName,
        query: {
          pid: this.$route.query.pid,
          rid: this.curId,
          type: this.buyNowOrMakeOfferBtn === "Select now" ? 2 : 1
        }
      });
    },
    propertyRoomListCallback(res) {
      var that = this;
      if (res.code === 0) {
        that.datum = res.data;
      } else if (res.code === 90000 || res.code === 90002) {
        console.log("callback 90000");
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.code === 8902 || res.code === 8901) {
        console.log("callback 8902");
        that.$box.alert("", res.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else {
        console.log("callback else error");
        that.$box.alert("", res.message, "error");
      }
    },
    choosed(index, roomId, status) {
      if (status === "Available") {
        var that = this;
        if (index !== that.cur) {
          that.cur = index;
          that.curId = roomId;
          that.disable = false;
        } else {
          that.cur = -1;
          that.curId = "";
          that.disable = true;
        }
      }
      this.buyNowOrMakeOfferBtn = this.getOfferType(index);
    },
    getOfferType(index) {
      const { totalPrice, totalPriceMax } = this.datum[index];
      if (totalPrice && (!totalPriceMax || totalPriceMax === totalPrice || totalPriceMax === 0)) {
        return "Select now";
      }
      return "Make Offer";
    },
  },
  mounted() {}
};
</script>

<template>
  <el-row>
    <el-col :span="24" style="padding: 40px;">
      <div
        style="border: 4px solid #cccccc; border-radius: 30px; padding: 20px;"
      >
        <el-row>
          <el-col :span="24"> </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="center-col">
            <span class="title-property-selection"
              >Select your new property</span
            >
          </el-col>
          <el-col :span="24" style="margin-top: 24px" class="center-col">
            <span class="para-property-selection" style="font-weight: bold">
              Complete your Reservation
            </span>
          </el-col>
          <el-col :span="24" style="margin-top: 10px" class="center-col">
            <span class="para-property-selection">
              Take advantage of UNIFI Property's unique online reservation function to reserve this property
            </span>
          </el-col>
          <el-col :span="24" style="margin-top: 10px" class="center-col">
            <span class="para-property-selection"
              >exclusively for your client for the next 7 days.
            </span>
          </el-col>
          <el-col :span="24" style="margin-top: 24px" class="center-col">
            <span class="para-property-selection">
              The UNIFI Property Concierge will be in contact with yourself and the vendor to progress the sale.
            </span>
          </el-col>
          <el-col :span="24" style="margin-top: 24px" class="center-col">
            <span class="para-property-selection">
              To start the process, select which of the available properties your client would like to reserve.
            </span>
          </el-col>
        </el-row>
        <el-row style="margin-top: 30px" :gutter="20">
          <el-col :offset="6" :span="4">
            <span class="label-available full-width">Available properties</span>
          </el-col>
          <el-col :span="4">
            <span class="label-sold full-width">Sold properties</span>
          </el-col>
          <el-col :span="4">
            <span class="label-reserved full-width">Reserved properties</span>
          </el-col>
        </el-row>
        <el-row
          :gutter="20"
          style="margin-top: 40px; display: flex; justify-content: center; flex-wrap: wrap"
        >
          <el-col
            :span="4"
            v-for="(item, index) in datum"
            :key="index"
            class="prop-tile"
          >
            <span
              :class="{
                'btn-prop-res': true,
                reserved: item.status == 'Reserved',
                sold:
                  item.status == 'Sold' ||
                  item.status == 'Unconditional' ||
                  item.status == 'Settled',
                available: item.status == 'Available',
                choosed: index == cur
              }"
              @click="choosed(index, item.roomId, item.status)"
            >
              {{ item.apt }}
            </span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="display: flex; justify-content: flex-end">
            <el-button
              :class="{
                'selection-continue disabled': datum.length === 0 || cur === -1,
                'selection-continue': datum.length > 0 && cur !== -1
              }"
              :disabled="datum.length === 0 || cur === -1"
              @click="reservePropertyForm"
              >{{ buyNowOrMakeOfferBtn }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-col>
  </el-row>
</template>

<style scoped>
.title-property-selection {
  color: #000000;
  font: 600 40px DINosaur-a, sans-serif;
  margin-top: 40px;
}

.para-property-selection {
  color: #000000;
  align-self: start;
  font: 400 18px DINosaur-a, sans-serif;
}

.label-available {
  font-family: DINosaur-a, sans-serif;
  color: #000000;
  background-color: #ffffff;
  border: 4px solid #cccccc;
  font-size: 18px;
  font-weight: 400;
  padding-top: 10px;
  padding-bottom: 10px;
}

.label-sold {
  font-family: DINosaur-a, sans-serif;
  color: #ffffff;
  background-color: #cccccc;
  border: 4px solid #cccccc;
  font-size: 18px;
  font-weight: 400;
  padding-top: 10px;
  padding-bottom: 10px;
}

.label-reserved {
  font-family: DINosaur-a, sans-serif;
  color: #ffffff;
  background-color: #003333;
  border: 4px solid #003333;
  font-size: 18px;
  font-weight: 400;
  padding-top: 10px;
  padding-bottom: 10px;
}

.full-width {
  display: flex;
  justify-content: center;
  width: 100%;
}

.prop-tile {
  margin: 0.5% 0;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.btn-prop-res {
  font-family: DINosaur-a, sans-serif;
  font-size: 20px;
  font-weight: 600;
  padding-top: 10px;
  padding-bottom: 10px;
  text-align: center;
}

.available {
  background-color: #ffffff;
  border: 4px solid #cccccc;
  cursor: pointer;
}

.sold {
  background-color: #cccccc;
  border: 4px solid #cccccc;
  cursor: not-allowed;
}

.reserved {
  background-color: #003333;
  border: 4px solid #003333;
  color: #ffffff;
  cursor: not-allowed;
}

.choosed {
  background: #757575;
  color: #ffffff;
}

.selection-continue {
  border-top-right-radius: 30px;
  background-color: #003333;
  margin-top: 40px;
  color: #ffffff;
  font: 400 20px DINosaur-a, sans-serif;
  transition: font-size 0.3s ease-in-out;
}

.selection-continue:hover {
  font: 400 21px DINosaur-a, sans-serif;
}

.selection-continue.disabled {
  opacity: 0.6;
  background-color: #003333;
  cursor: not-allowed;
}

.selection-continue.disabled:hover {
  opacity: 0.7;
  cursor: not-allowed;
}

.center-col {
  display: flex;
  justify-content: center;
}

@media (max-width: 991px) {
  .selection-continue {
    margin-top: 40px;
    white-space: initial;
    padding: 0 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/uConnectReservation/propertySelection.vue